import { render, staticRenderFns } from "./CountryFlags.vue?vue&type=template&id=315466dc&"
import script from "./CountryFlags.vue?vue&type=script&lang=js&"
export * from "./CountryFlags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports